package kz.dentalcrm.app.screens.splash.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface SplashViewSideEffect : ViewSideEffect {
    data object NavigateToMain : SplashViewSideEffect
    data object NavigateToLogin : SplashViewSideEffect
}
